import CampaignTracking from '@frontend/app/features/CampaignTracking';
import ConvertedWithTracking from '@frontend/app/features/ConvertedWithTracking';
import MatomoTracker from '@frontend/app/features/MatomoTracker';
import queryString from 'query-string';

export default class SteadyCheckoutWidget {
  static init() {
    if (window.top.__steadyCheckoutWidgetInitiated === true) return true;
    window.top.__steadyCheckoutWidgetInitiated = true;
    this.start();
  }

  static start() {
    this.maxInitAttempts = 5;
    this.initAttempt = this.initAttempt || 0;
    this.initAttempt += 1;

    if (!this.isReady() && this.initAttempt <= this.maxInitAttempts) {
      setTimeout(() => this.start(), 500);
    } else if (this.getSteadyCheckoutWidgetPlaceholder()) {
      this.maybeAddUTMCampaignDataAttributes();
      this.loadSteadyCheckoutWidgetJs();
    }
  }

  static getSteadyCheckoutWidgetPlaceholderId() {
    return 'insert_steady_checkout_here';
  }

  static isReady() {
    return (
      this.checkoutIsConfiguredAndEnabled() &&
      this.getSteadyCheckoutWidgetPlaceholder() !== undefined &&
      this.matomoTrackerIsReady()
    );
  }

  static matomoTrackerIsReady() {
    return MatomoTracker.isReady();
  }

  static checkoutIsConfiguredAndEnabled() {
    return (
      window &&
      window.ENV &&
      window.ENV.steady &&
      window.ENV.steady.checkoutWidget.enabled &&
      window.ENV.steady.checkoutWidget.url
    );
  }

  static getSteadyCheckoutWidgetJsUrl() {
    return window.ENV.steady.checkoutWidget.url;
  }

  static getSteadyOAuthAccessToken() {
    return window.ENV.steady.checkoutWidget.oauthAccessToken;
  }

  static getSteadyCheckoutWidgetPlaceholder() {
    return window.top.document.querySelector(
      `#${this.getSteadyCheckoutWidgetPlaceholderId()}`
    );
  }

  static maybeAddUTMCampaignDataAttributes() {
    const steadyWidgetPlaceholder = this.getSteadyCheckoutWidgetPlaceholder();
    steadyWidgetPlaceholder.dataset.utmCampaign =
      this.currentSteadyPublisherUtmCampaignOrBuildUtmCampaign();
  }

  static currentSteadyPublisherUtmCampaignOrBuildUtmCampaign() {
    const query = queryString.parse(window.top.location.search);
    const overlayUrl = query['steady_overlay_url'];

    if (overlayUrl) {
      const overlayQuery = queryString.parse(overlayUrl);

      if (overlayQuery['steady_publisher_utm_campaign']) {
        return overlayQuery['steady_publisher_utm_campaign'];
      }
    }

    return this.generateUtmCampaignTracking();
  }

  // Defines the custom utm_campaign-value we pass to steady as the `steady_publisher_utm_campaign`
  // This special utm_campaign-value carries multiple dimensions of information.
  //
  // a) The original utm_campaign which was present when a user visited an article
  // b) A converted_with value which identifies the article and an optional share-url
  static generateUtmCampaignTracking() {
    return [
      this.getCurrentCampaignTracking(),
      ConvertedWithTracking.getCurrentConvertedWith(),
    ]
      .filter((x) => x.length > 1)
      .join('__');
  }

  static getCurrentCampaignTracking() {
    const activeCampaign = CampaignTracking.getCurrentCampaign();
    if (activeCampaign) {
      return activeCampaign.replace('__', '--').substr(0, 200);
    } else {
      return '';
    }
  }

  static loadSteadyCheckoutWidgetJs() {
    if (window.___steadyCheckoutWidgetJsLoading) return true;

    var script = document.createElement('script');
    script.src = this.getSteadyCheckoutWidgetJsUrl();
    if (this.getSteadyOAuthAccessToken()) {
      script.dataset.steadyOauthAccessToken = this.getSteadyOAuthAccessToken();
    }
    window.top.document.body.appendChild(script);

    window.___steadyCheckoutWidgetJsLoading = true;
  }
}
